import React from 'react'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";

// const data = [
//     { "month": "Jan", "users": 123, "queries": 345 },
//     { "month": "Feb", "users": 123, "queries": 123 },
//     { "month": "Mar", "users": 123, "queries": 12 }
// ]

const Graph = ({ data, title }) => {
    return (
        <div className="w-[100%] h-[100%] flex flex-col">
            <h1 className='font-semibold mb-8 ml-2'>{title}</h1>
            <div className="flex-1 min-h-0">
                <ResponsiveContainer>
                    <LineChart data={data} margin={{ top: 20, right: 10 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                            type="monotone"
                            dataKey="users"
                            name="Monthly Active Users"
                            stroke="#8884d8"
                            strokeWidth={2}
                            label={{ position: "top" }}
                        />

                        {/* Second Line */}
                        <Line
                            type="monotone"
                            dataKey="queries"
                            name="Queries"
                            stroke="#82ca9d"
                            strokeWidth={2}
                            label={{ position: "top" }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>


        </div>
    )
}

export default Graph
